export default "__VITE_ASSET__72d92d74__"